export const Constants = Object.freeze({
  NESTED_QUOTA_LIMIT: 4,
});
